import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import RegistrationForm from './components/RegistrationForm';
import WelcomeMessage from './components/WelcomeMessage';
import LoginRedirect from './components/LoginRedirect';
import EmailVerificationInfo from './components/EmailVerificationInfo';

const RegisterPage = () => {
  const [showEmailVerification, setShowEmailVerification] = useState(false);
  const [registeredEmail, setRegisteredEmail] = useState('');

  const handleRegistrationSuccess = (email) => {
    setRegisteredEmail(email);
    setShowEmailVerification(true);
  };

  const handleResendVerification = () => {
    // Handle resend verification logic
    console.log('Resending verification email to:', registeredEmail);
  };

  return (
    <>
      <Helmet>
        <title>Registrieren - Vierdimensional | KI-Chatbots für Ihre Website</title>
        <meta 
          name="description" 
          content="Erstellen Sie Ihr kostenloses Vierdimensional-Konto und beginnen Sie mit der Erstellung professioneller KI-Chatbots für Ihre Websites." 
        />
        <meta name="keywords" content="registrieren, konto erstellen, ki chatbot, vierdimensional, anmeldung" />
        <meta property="og:title" content="Registrieren - Vierdimensional" />
        <meta property="og:description" content="Erstellen Sie Ihr kostenloses Konto und beginnen Sie mit KI-Chatbots" />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://vierdimensional.de/register" />
      </Helmet>
      <div className="min-h-screen bg-background">
        <div className="flex min-h-screen">
          {/* Left Side - Welcome Message (Hidden on mobile) */}
          <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-primary/5 to-secondary/5 p-12 items-center justify-center">
            <div className="max-w-md w-full">
              <WelcomeMessage />
            </div>
          </div>

          {/* Right Side - Registration Form */}
          <div className="w-full lg:w-1/2 flex items-center justify-center p-6 lg:p-12">
            <div className="max-w-md w-full space-y-8">
              {/* Mobile Logo (Visible only on mobile) */}
              <div className="lg:hidden text-center mb-8">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4">
                  <img 
                    src="/assets/images/Kein_Titel_900_x_1024_px_2_-1757417528542.png" 
                    alt="Vierdimensional Logo" 
                    className="w-12 h-12 object-contain"
                  />
                </div>
                <h1 className="text-2xl font-bold text-foreground font-heading">
                  Vierdimensional
                </h1>
                <p className="text-sm text-muted-foreground mt-2">
                  KI-Chatbots für Ihre Website
                </p>
              </div>

              {/* Registration Header */}
              <div className="text-center lg:text-left">
                <h2 className="text-3xl font-bold text-foreground mb-2 font-heading">
                  Konto erstellen
                </h2>
                <p className="text-muted-foreground">
                  Beginnen Sie noch heute mit der Erstellung Ihrer KI-Chatbots
                </p>
              </div>

              {/* Email Verification Info or Registration Form */}
              {showEmailVerification ? (
                <div className="space-y-6">
                  <EmailVerificationInfo 
                    email={registeredEmail}
                    onResendVerification={handleResendVerification}
                  />
                  <LoginRedirect />
                </div>
              ) : (
                <div className="space-y-6">
                  <RegistrationForm onSuccess={handleRegistrationSuccess} />
                  <LoginRedirect />
                </div>
              )}

              {/* Footer */}
              <div className="text-center pt-6">
                <p className="text-xs text-muted-foreground">
                  © {new Date()?.getFullYear()} Vierdimensional. Alle Rechte vorbehalten.
                </p>
                <div className="flex items-center justify-center space-x-4 mt-2">
                  <a href="/privacy" className="text-xs text-muted-foreground hover:text-primary transition-colors">
                    Datenschutz
                  </a>
                  <span className="text-xs text-muted-foreground">•</span>
                  <a href="/terms" className="text-xs text-muted-foreground hover:text-primary transition-colors">
                    AGB
                  </a>
                  <span className="text-xs text-muted-foreground">•</span>
                  <a href="/imprint" className="text-xs text-muted-foreground hover:text-primary transition-colors">
                    Impressum
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RegisterPage;